import { css } from '@emotion/core';

export const meetViewStyle =
  /* istanbul ignore next */
  css`
    width: 100%;

    .candidate-card-header {
      @media (max-width: 568px) {
        padding-right: 50px !important;
      }

      @media screen and (max-width: 922px) and (orientation: landscape) {
        flex-direction: column;
        align-items: flex-start;

        .chakra-badge {
          margin-bottom: 5px;
        }
      }
    }

    .meet-card-header {
      padding: 1rem 1.5rem;
      background: #ffeee3;

      h3 {
        margin-bottom: 5px;
      }

      p {
        font-size: 14px;

        @media (max-width: 480px) {
          font-size: 12px;
        }
      }
    }
    .meet-card-body {
      padding: 1rem 1.5rem;

      .chakra-button {
        padding-left: 2rem;
        padding-right: 2rem;
      }
    }
  `;

export const greenRoomPage = css`
  height: calc(100vh - 100px);
  max-width: 1100px;
  margin: auto;
  min-height: 420px;
  gap: clamp(24px, 4vw, 64px);

  @media (max-width: 768px) {
    height: auto;
    min-height: 100dvh;
    padding: 24px 16px;
  }

  @media (max-width: 480px) {
    height: auto;
    min-height: unset;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    padding: 16px 0 24px;
    gap: 24px;
  }

  @media (max-width: 922px) and (orientation: landscape) {
    height: auto;
    flex-direction: column;
    padding: 12px 16px;
  }
`;

export const greenRoomVideoBlock = css`
  position: relative;
  flex-shrink: 0;

  // width: clamp(200px, 32vw, 380px);
  height: 100%;
  aspect-ratio: 9 / 16;

  @media (max-width: 1024px) {
    width: clamp(180px, 30vw, 300px);
  }

  @media (max-width: 480px) {
    width: min(72vw, 260px);
    margin: 0 auto;
  }

  @media (max-width: 922px) and (orientation: landscape) {
    width: auto;
    height: clamp(120px, 40vh, 220px);
    aspect-ratio: 9 / 16;
  }
`;

export const greenRoomVideoInner = css`
  position: absolute;
  inset: 0;
  border-radius: 16px;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }
`;

export const greenRoomVideoControls = css`
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  gap: 10px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.56);
  padding: 6px;
  border-radius: 50px;
  width: max-content;

  @media (max-width: 480px) {
    right: 10px;
    bottom: 12px;
    gap: 8px;
  }

  .chakra-button {
    padding: 0;
    margin: 0;
    font-size: 22px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.56);
    flex-shrink: 0;
    &.active {
      background: #3182ce;
      color: #fff;
    }

    @media (max-width: 360px) {
      font-size: 18px;
      width: 34px;
      height: 34px;
    }

    &:not(.video-effects-button) svg path {
      fill: #fff;
    }

    &:focus,
    &:active,
    &:hover {
      outline: none;
      box-shadow: none;
      border: 0;
    }

    &.off svg path {
      fill: #f34d4f;
    }
  }
`;

export const greenRoomRightPanel = css`
  position: relative;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  max-width: clamp(300px, 32vw, 400px);

  @media (max-width: 480px) {
    width: 100%;
    overflow: visible;
  }
`;

export const greenRoomTitle = css`
  font-weight: 600;
`;

export const hintBoxStyle = css`
  background: #ffeee3;
  border: 1px dashed #ff6600;
`;
